/* global axios */
import ApiClient from './ApiClient';

class AiReviewsAPI extends ApiClient {
  constructor() {
    super('ai_reviews', { accountScoped: true });
  }

  getReviewPolicies() {
    return axios.get(`${this.url}/review_policies`);
  }

  createReviewPolicy(attributes) {
    return axios.post(`${this.url}/review_policies`, {
      review_policy: attributes,
    });
  }

  getReviewPolicy(id) {
    return axios.get(`${this.url}/review_policies/${id}`);
  }

  getReviewPolicyVersion(id) {
    return axios.get(`${this.url}/review_policy_versions/${id}`);
  }

  createReviewPolicyVersion(policyId, sourceVersionId) {
    return axios.post(`${this.url}/review_policies/${policyId}/versions`, {
      source_version_id: sourceVersionId,
    });
  }

  updateReviewPolicyVersion(id, attributes) {
    return axios.patch(`${this.url}/review_policy_versions/${id}`, {
      review_policy_version: attributes,
    });
  }

  publishReviewPolicyVersion(id) {
    return axios.post(`${this.url}/review_policy_versions/${id}/publish`);
  }

  getKnowledgeBases() {
    return axios.get(`${this.url}/knowledge_bases`);
  }

  createKnowledgeBase(attributes) {
    return axios.post(`${this.url}/knowledge_bases`, {
      knowledge_base: attributes,
    });
  }

  getKnowledgeBase(id) {
    return axios.get(`${this.url}/knowledge_bases/${id}`);
  }

  getKnowledgeBaseVersion(id) {
    return axios.get(`${this.url}/knowledge_base_versions/${id}`);
  }

  createKnowledgeBaseVersion(knowledgeBaseId, sourceVersionId) {
    return axios.post(
      `${this.url}/knowledge_bases/${knowledgeBaseId}/versions`,
      { source_version_id: sourceVersionId }
    );
  }

  publishKnowledgeBaseVersion(id) {
    return axios.post(`${this.url}/knowledge_base_versions/${id}/publish`);
  }

  createKnowledgeBaseEntry(versionId, attributes) {
    return axios.post(
      `${this.url}/knowledge_base_versions/${versionId}/entries`,
      { knowledge_base_entry: attributes }
    );
  }

  updateKnowledgeBaseEntry(id, attributes) {
    return axios.patch(`${this.url}/knowledge_base_entries/${id}`, {
      knowledge_base_entry: attributes,
    });
  }

  deleteKnowledgeBaseEntry(id) {
    return axios.delete(`${this.url}/knowledge_base_entries/${id}`);
  }

  reorderKnowledgeBaseEntries(versionId, entryIds) {
    return axios.patch(
      `${this.url}/knowledge_base_versions/${versionId}/reorder`,
      { entry_ids: entryIds }
    );
  }

  getModelProfiles() {
    return axios.get(`${this.url}/model_profiles`);
  }

  getModelProfile(id) {
    return axios.get(`${this.url}/model_profiles/${id}`);
  }

  createModelProfile(attributes) {
    return axios.post(`${this.url}/model_profiles`, {
      model_profile: attributes,
    });
  }

  updateModelProfile(id, attributes) {
    return axios.patch(`${this.url}/model_profiles/${id}`, {
      model_profile: attributes,
    });
  }

  reorderModelProfiles(profileIds) {
    return axios.patch(`${this.url}/model_profiles/reorder`, {
      profile_ids: profileIds,
    });
  }

  previewBatch(attributes) {
    return axios.post(`${this.url}/batch_preview`, {
      ai_review_batch: attributes,
    });
  }

  getBatches(page = 1) {
    return axios.get(`${this.url}/batches`, { params: { page } });
  }

  createBatch(attributes) {
    return axios.post(`${this.url}/batches`, {
      ai_review_batch: attributes,
    });
  }

  getBatch(id, page = 1, filters = {}) {
    return axios.get(`${this.url}/batches/${id}`, {
      params: { page, ...filters },
    });
  }

  getReview(id) {
    return axios.get(`${this.url}/reviews/${id}`);
  }

  retryReview(id) {
    return axios.post(`${this.url}/reviews/${id}/retry`);
  }
}

export default new AiReviewsAPI();
